import React, { useState, useEffect } from 'react';
import Icons from './Icons';

function Navbar() {
	const [isOpen, setIsOpen] = useState(false);
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => setScrolled(window.scrollY > 50);
		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, []);

	const navLinks = [
		{ name: 'Inicio', href: '#inicio' },
		{ name: 'Minerales', href: '#minerales' },
		{ name: 'Servicios', href: '#servicios' },
		{ name: 'Nosotros', href: '#nosotros' },
		{ name: 'Contacto', href: '#contacto' },
	];

	return (
		<nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="flex justify-between items-center h-20">
					<a href="#inicio" className="flex items-center space-x-3">
						<div className="w-10 h-10 bg-gradient-to-br from-mineral-500 to-gold-500 rounded-lg flex items-center justify-center">
							<Icons.Gem />
						</div>
						<span className={`text-2xl font-bold ${scrolled ? 'text-mineral-900' : 'text-white'}`}>
							CM-<span className="text-mineral-400">WTP</span>
						</span>
					</a>
					<div className="hidden md:flex items-center space-x-8">
						{navLinks.map(link => (
							<a key={link.name} href={link.href} className={`font-medium hover:text-mineral-500 transition-colors ${scrolled ? 'text-slate-700' : 'text-white/90'}`}>
								{link.name}
							</a>
						))}
						<a href="#contacto" className="bg-gradient-to-r from-mineral-500 to-mineral-600 text-white px-6 py-2.5 rounded-full font-medium hover:shadow-lg hover:shadow-mineral-500/30 transition-all transform hover:-translate-y-0.5">
							Cotizar Ahora
						</a>
					</div>
					<button onClick={() => setIsOpen(!isOpen)} className={`md:hidden ${scrolled ? 'text-slate-800' : 'text-white'}`}>
						{isOpen ? <Icons.X /> : <Icons.Menu />}
					</button>
				</div>
			</div>
			{isOpen && (
				<div className="md:hidden bg-white border-t shadow-xl">
					<div className="px-4 pt-2 pb-6 space-y-1">
						{navLinks.map(link => (
							<a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="block px-4 py-3 text-slate-700 hover:bg-mineral-50 hover:text-mineral-600 rounded-lg font-medium transition-colors">
								{link.name}
							</a>
						))}
						<a href="#contacto" onClick={() => setIsOpen(false)} className="block mt-4 bg-mineral-600 text-white text-center px-6 py-3 rounded-lg font-medium">
							Cotizar Ahora
						</a>
					</div>
				</div>
			)}
		</nav>
	);
}

export default Navbar;
